var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimaryLarge = function SvgPrimaryLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 264 264"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC2015",
    d: "M245.589 152.386c0 64.234-88.761 87.963-153.022 87.963-64.262 0-74.312-72.597-74.312-136.832 0-64.234 83.383-79.655 147.645-79.655 64.261 0 79.689 64.29 79.689 128.524"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#primary-large_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#primary-large_svg__b)",
    fillOpacity: 0.3,
    d: "M2.01 65.88C44.128 44.223 124.198.97 124.198.97c1.009 1.321 1.933 2.6 2.79 3.838.306.44.381 1.76.381 1.76s1.047.35 1.306.745c.809 1.235 1.56 2.425 2.273 3.57.198.317-1.006 2.286-1.006 2.286s1.957-.753 2.137-.462c3.16 5.102 5.755 9.22 9.94 12.35l7.674 12.338C84.374 73.02 12.701 107.018 12.701 107.018c1.077-9.125-3.02-4.768-4.168-11.599-.077-.458.834-1.654.744-2.16-.093-.53-1.169-.667-1.27-1.726-.267-2.793-.663-7.032-1.724-10.627-.143-.484.422-1.591.422-1.591l-1.25-1.23-1.093-3.763.16-3.035-1.613-2.15z",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#primary-large_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#primary-large_svg__d)",
    fillOpacity: 0.3,
    d: "M254.304 201.368c-42.951 19.958-124.685 59.978-124.685 59.978a100 100 0 0 1-2.635-3.945c-.287-.453-.31-1.774-.31-1.774s-1.032-.392-1.275-.797a180 180 0 0 1-2.128-3.657c-.185-.325 1.096-2.244 1.096-2.244s-1.985.674-2.154.376c-2.954-5.225-5.381-9.443-9.438-12.737l-7.175-12.635c66.691-32.988 139.665-64.098 139.665-64.098-1.441 9.075 2.827 4.886 3.701 11.757.058.461-.899 1.619-.83 2.129.072.533 1.142.713 1.201 1.775.155 2.802.381 7.053 1.297 10.687.124.49-.485 1.573-.485 1.573l1.2 1.279.941 3.804-.281 3.026 1.527 2.213z",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary-large_svg__b",
    x1: 5.814,
    x2: 135.598,
    y1: 96.009,
    y2: 20.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary-large_svg__d",
    x1: 251.706,
    x2: 119.023,
    y1: 171.111,
    y2: 240.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "primary-large_svg__a",
    width: 149.683,
    height: 109.048,
    x: 1.01,
    y: 0.971,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_976_60059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_976_60059",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_976_60059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "primary-large_svg__c",
    width: 150.704,
    height: 104.511,
    x: 104.6,
    y: 159.835,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_976_60059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_976_60059",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_976_60059"
  })))));
};
export default SvgPrimaryLarge;